import { render, staticRenderFns } from "./AppsContainer.vue?vue&type=template&id=2b9c6ebd"
import script from "./AppsContainer.vue?vue&type=script&lang=ts"
export * from "./AppsContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports